import React from "react";

import { useNavigate } from "react-router-dom";  

const filters = [
  "Now Showing",
  "Advance Booking",
  "New This Week",
  "Last Chance to Watch",
  "Coming Soon",
];

const movies = [
  {
    title: "the social network",
    badge: "CLASSIC",
    rating: "R18",
    img: "/f1.jpg",
  },
  {
    title: "THUNDERBOLTS*",
    badge: "",
    rating: "PG12",
    img: "/f2.jpg",
    subtitle: "ONLY IN CINEMAS MAY 1",
  },
  {
    title: "HEART EYES",
    badge: "NEW",
    rating: "R18",
    img: "/f3.jpg",
    subtitle: "MAY 8",
  },
  {
    title: "SIKO SIKO",
    badge: "",
    rating: "R15",
    img: "/f4.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE ACCOUNTANT 2",
    badge: "",
    rating: "R15",
    img: "/f5.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE LEGEND OF OCHI",
    badge: "NEW",
    rating: "PG",
    img: "/f6.jpg",
    subtitle: "",
  },
  {
    title: "the social network",
    badge: "CLASSIC",
    rating: "R18",
    img: "/f7.jpg",
  },
  {
    title: "THUNDERBOLTS*",
    badge: "",
    rating: "PG12",
    img: "/f8.jpg",
    subtitle: "ONLY IN CINEMAS MAY 1",
  },
  {
    title: "HEART EYES",
    badge: "NEW",
    rating: "R18",
    img: "/f9.jpg",
    subtitle: "MAY 8",
  },
  {
    title: "SIKO SIKO",
    badge: "",
    rating: "R15",
    img: "/f10.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE ACCOUNTANT 2",
    badge: "",
    rating: "R15",
    img: "/f11.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE LEGEND OF OCHI",
    badge: "NEW",
    rating: "PG",
    img: "/f12.jpg",
    subtitle: "",
  },
  {
    title: "the social network",
    badge: "CLASSIC",
    rating: "R18",
    img: "/f13.jpg",
  },
  {
    title: "THUNDERBOLTS*",
    badge: "",
    rating: "PG12",
    img: "/f14.jpg",
    subtitle: "ONLY IN CINEMAS MAY 1",
  },
  {
    title: "HEART EYES",
    badge: "NEW",
    rating: "R18",
    img: "/f15.jpg",
    subtitle: "MAY 8",
  },
  {
    title: "SIKO SIKO",
    badge: "",
    rating: "R15",
    img: "/f16.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE ACCOUNTANT 2",
    badge: "",
    rating: "R15",
    img: "/f17.jpg",
    subtitle: "April 24",
  },
  {
    title: "Gergasha",
    badge: "NEW",
    rating: "G",
    img: "/f18.jpg",
    subtitle: "",
  },
  {
    title: "the social network",
    badge: "CLASSIC",
    rating: "R18",
    img: "/f19.jpg",
  },
  {
    title: "THUNDERBOLTS*",
    badge: "",
    rating: "PG",
    img: "/f20.jpg",
    subtitle: "ONLY IN CINEMAS MAY 1",
  },
  {
    title: "HEART EYES",
    badge: "NEW",
    rating: "R18",
    img: "/f21.jpg",
    subtitle: "MAY 8",
  },
  {
    title: "SIKO SIKO",
    badge: "",
    rating: "R15",
    img: "/f22.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE ACCOUNTANT 2",
    badge: "",
    rating: "PG12",
    img: "/f24.jpg",
    subtitle: "April 24",
  },
  {
    title: "THE LEGEND OF OCHI",
    badge: "NEW",
    rating: "PG",
    img: "/f25.jpg",
    subtitle: "",
  },
];

const MovieGallery = () => {

  
const navigate = useNavigate()


  return (
    <div className="p-4 md:p-8">
      {/* Filter Tabs */}
      <div className="flex flex-wrap items-center justify-between bg-red-600 rounded-lg text-white font-medium overflow-x-auto text-sm md:text-base">
        <div className="flex flex-nowrap overflow-x-auto">
          {filters.map((f, i) => (
            <button
              key={i}
              className={`min-w-[130px] whitespace-nowrap px-4 py-3 border-r border-red-700 hover:bg-red-700 ${
                i === 0 ? "font-bold text-white" : "text-white"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
        <button className="flex items-center px-4 py-3 gap-1 hover:bg-red-700 shrink-0">
          Filters
          <span className="text-lg">⚙️</span>
        </button>
      </div>

      {/* Movie Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-4 mt-8">
        {movies.map((movie, i) => (
          <div
            key={i}
            className="relative bg-black rounded-xl overflow-hidden shadow-lg group"
          >
            {/* Tag */}
            {movie.badge && (
              <div className="absolute top-0 left-0 bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded-br">
                {movie.badge}
              </div>
            )}

            <img  onClick={()=>navigate('/moviesessions')}
              src={movie.img}
              alt={movie.title}
              className="w-full h-48 sm:h-56 md:h-[310px] object-cover transform transition-transform duration-500 group-hover:scale-110 rounded-xl"
            />

            {/* Overlay on hover */}
            <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <button onClick={()=>navigate('/moviesessions')} className="bg-red-600 text-white px-4 py-2 text-sm font-semibold rounded">
                Book Now
              </button>
            </div>

            {/* Title overlay */}
            <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent p-2">
              <div className="text-white font-bold text-sm">
                {movie.title}
              </div>
              {movie.subtitle && (
                <div className="text-xs text-gray-300">{movie.subtitle}</div>
              )}
            </div>

            {/* Rating */}
            <div className="absolute bottom-2 right-2 bg-red-600 text-white text-xs font-semibold px-2 py-0.5 rounded">
              {movie.rating}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MovieGallery;
